import { FormattedMessage } from 'react-intl';

// Language
export enum LANGUAGE_NAME_ENUM {
  TURKISH = 'tr',
  ENGLISH = 'en',
}

export const getLanguageTranslated = (language: string) =>
  ({
    [LANGUAGE_NAME_ENUM.TURKISH]: <FormattedMessage id="language.turkish" defaultMessage="Türkçe" />,
    [LANGUAGE_NAME_ENUM.ENGLISH]: <FormattedMessage id="language.english" defaultMessage="İngilizce" />,
  })[language];

export const getLanguageFlagSrc = (language: string) =>
  ({
    [LANGUAGE_NAME_ENUM.TURKISH]: 'https://flagcdn.com/tr.svg',
    [LANGUAGE_NAME_ENUM.ENGLISH]: 'https://flagcdn.com/gb.svg',
  })[language];

// Storage Keys
export enum STORAGE_KEY_ENUM {
  TOKEN = 'token',
  LANGUAGE = 'language',
  VERSION = 'app-version',
  THEME_MODE = 'theme-mode',
  LOGGED_USER = 'logged-user',
  MEETING_MODE = 'meeting-mode',
  ALL_SHOW_BOOKS = 'all-show-books',
  NON_INITIALIZED = 'non-initialized',
  UPDATE_FULL_BOOK = 'update-full-book',
  UPDATE_COMPANY_NAME = 'update-company-name',
}

export enum TABLE_SCHEMA_PAGE_NAME_ENUM {
  ACTIVITY_MANAGING = 'activity-managing',
  EFFORT_TRACING = 'effort-tracing',
  PROJECT_MONITORING = 'project-monitoring',
  PROJECT_STEP_MANAGING = 'project-step-managing',
}

export enum STATUS_TYPE_ENUM {
  PASSIVE = 0,
  ACTIVE = 1,
}

export const getStatusTypeTranslated = (statusType: number) =>
  ({
    [STATUS_TYPE_ENUM.PASSIVE]: <FormattedMessage id="enum.statusType.passive" defaultMessage="Pasif" />,
    [STATUS_TYPE_ENUM.ACTIVE]: <FormattedMessage id="enum.statusType.active" defaultMessage="Aktif" />,
  })[statusType];

export enum PROCESS_TYPE_ENUM {
  ACCOUNT = 0,
  BOOK = 1,
  CONNECTION_TYPE = 2,
  ENVIRONMENT_TYPE = 3,
  GIB_TYPE = 4,
  ME = 5,
  PERMISSION = 6,
  PROJECT = 7,
  PROJECT_GROUP = 8,
  ROLE = 9,
  USED_BANK = 10,
  USER = 11,
  VERSION = 12,
  EFFORT_REQUEST = 13,
  EFFORT_CONTACT = 14,
  EFFORT_STATUS_CONTACT = 15,
  PROJECT_TASK_BASE = 16,
  ACTIVITY_TYPE = 17,
  PROJECT_TASK = 18,
}

export const getProcessTypeTranslated = (processType: number) =>
  ({
    [PROCESS_TYPE_ENUM.ACCOUNT]: <FormattedMessage id="enum.processType.account" defaultMessage="Hesap" />,
    [PROCESS_TYPE_ENUM.BOOK]: <FormattedMessage id="enum.processType.book" defaultMessage="Proje" />,
    [PROCESS_TYPE_ENUM.CONNECTION_TYPE]: (
      <FormattedMessage id="enum.processType.connectionType" defaultMessage="Bağlantı Türü" />
    ),
    [PROCESS_TYPE_ENUM.ENVIRONMENT_TYPE]: (
      <FormattedMessage id="enum.processType.environmentType" defaultMessage="Sunucu Tipi" />
    ),
    [PROCESS_TYPE_ENUM.GIB_TYPE]: <FormattedMessage id="enum.processType.gibType" defaultMessage="Gib Yöntemi" />,
    [PROCESS_TYPE_ENUM.ME]: <FormattedMessage id="enum.processType.me" defaultMessage="Profil" />,
    [PROCESS_TYPE_ENUM.PERMISSION]: <FormattedMessage id="enum.processType.permission" defaultMessage="İzin" />,
    [PROCESS_TYPE_ENUM.PROJECT]: <FormattedMessage id="enum.processType.project" defaultMessage="Ürün" />,
    [PROCESS_TYPE_ENUM.PROJECT_GROUP]: (
      <FormattedMessage id="enum.processType.projectGroup" defaultMessage="Ürün Grubu" />
    ),
    [PROCESS_TYPE_ENUM.ROLE]: <FormattedMessage id="enum.processType.role" defaultMessage="Rol" />,
    [PROCESS_TYPE_ENUM.USED_BANK]: (
      <FormattedMessage id="enum.processType.usedBank" defaultMessage="Kullanılan Banka" />
    ),
    [PROCESS_TYPE_ENUM.USER]: <FormattedMessage id="enum.processType.user" defaultMessage="Kullanıcı" />,
    [PROCESS_TYPE_ENUM.VERSION]: <FormattedMessage id="enum.processType.version" defaultMessage="Version" />,
    [PROCESS_TYPE_ENUM.EFFORT_REQUEST]: (
      <FormattedMessage id="enum.processType.effortRequest" defaultMessage="Efor Talebi" />
    ),
    [PROCESS_TYPE_ENUM.EFFORT_CONTACT]: (
      <FormattedMessage id="enum.processType.effortContact" defaultMessage="Efor Muhatabı" />
    ),
    [PROCESS_TYPE_ENUM.EFFORT_STATUS_CONTACT]: (
      <FormattedMessage id="enum.processType.effortStatusContact" defaultMessage="Efor Statü Muhatabı" />
    ),
    [PROCESS_TYPE_ENUM.PROJECT_TASK_BASE]: (
      <FormattedMessage id="enum.processType.projectTaskBase" defaultMessage="Ürün - Proje Planı" />
    ),
    [PROCESS_TYPE_ENUM.ACTIVITY_TYPE]: (
      <FormattedMessage id="enum.processType.activityType" defaultMessage="Aktivite Tipi" />
    ),
    [PROCESS_TYPE_ENUM.PROJECT_TASK]: (
      <FormattedMessage id="enum.processType.projectTask" defaultMessage="Proje Adımı" />
    ),
  })[processType];

export enum ACTION_TYPE_ENUM {
  INSERT = 0,
  DELETE = 1,
  UPDATE = 2,
  SIGN_IN = 3,
  RESTORE = 4,
  ASSIGN = 5,
  SEND_EMAIL = 6,
}

export const getActionTypeTranslated = (actionType: number) =>
  ({
    [ACTION_TYPE_ENUM.INSERT]: <FormattedMessage id="enum.actionType.insert" defaultMessage="Ekleme" />,
    [ACTION_TYPE_ENUM.DELETE]: <FormattedMessage id="enum.actionType.delete" defaultMessage="Silme" />,
    [ACTION_TYPE_ENUM.UPDATE]: <FormattedMessage id="enum.actionType.update" defaultMessage="Güncelleme" />,
    [ACTION_TYPE_ENUM.SIGN_IN]: <FormattedMessage id="enum.actionType.signIn" defaultMessage="Giriş" />,
    [ACTION_TYPE_ENUM.RESTORE]: <FormattedMessage id="enum.actionType.restore" defaultMessage="Yenileme" />,
    [ACTION_TYPE_ENUM.ASSIGN]: <FormattedMessage id="enum.actionType.assign" defaultMessage="Atama" />,
    [ACTION_TYPE_ENUM.SEND_EMAIL]: (
      <FormattedMessage id="enum.actionType.sendEmail" defaultMessage="Hatırlatma E-Postası" />
    ),
  })[actionType];

export enum EXPORT_TYPE_ENUM {
  EXCEL = 1,
  CSV = 3,
}

export enum EFFORT_STATUS_TYPE_ENUM {
  IN_SALES = 1,
  PENDING_CUSTOMER_APPROVAL = 2,
  APPROVED = 3,
  REJECTED = 4,
  WORK_STARTED = 5,
  TESTING_BY_CUSTOMER = 6,
  WORK_COMPLETED = 7,
  INVOICED = 8,
}

export const getEffortStatusTypeTranslated = (effortStatusType: number) =>
  ({
    [EFFORT_STATUS_TYPE_ENUM.IN_SALES]: (
      <FormattedMessage id="enum.effortStatusType.inSales" defaultMessage="Satış Ekibinde" />
    ),
    [EFFORT_STATUS_TYPE_ENUM.PENDING_CUSTOMER_APPROVAL]: (
      <FormattedMessage id="enum.effortStatusType.pendingCustomerApproval" defaultMessage="Müşteri Onayında" />
    ),
    [EFFORT_STATUS_TYPE_ENUM.APPROVED]: (
      <FormattedMessage id="enum.effortStatusType.approved" defaultMessage="Efor Onaylandı" />
    ),
    [EFFORT_STATUS_TYPE_ENUM.REJECTED]: (
      <FormattedMessage id="enum.effortStatusType.rejected" defaultMessage="Efor Reddedildi" />
    ),
    [EFFORT_STATUS_TYPE_ENUM.WORK_STARTED]: (
      <FormattedMessage id="enum.effortStatusType.workStarted" defaultMessage="Çalışma Başlatıldı" />
    ),
    [EFFORT_STATUS_TYPE_ENUM.TESTING_BY_CUSTOMER]: (
      <FormattedMessage id="enum.effortStatusType.testingByCustomer" defaultMessage="Müşteri Testinde" />
    ),
    [EFFORT_STATUS_TYPE_ENUM.WORK_COMPLETED]: (
      <FormattedMessage id="enum.effortStatusType.workCompleted" defaultMessage="Çalışma Tamamlandı" />
    ),
    [EFFORT_STATUS_TYPE_ENUM.INVOICED]: (
      <FormattedMessage id="enum.effortStatusType.invoiced" defaultMessage="Faturası Kesildi" />
    ),
  })[effortStatusType];

export enum PROJECT_STEP_PRIORITY_TYPE_ENUM {
  NON_URGENT = 1,
  URGENT = 2,
  VERY_URGENT = 3,
}

export const getProjectStepPriorityTypeTranslated = (projectStepPriorityType: number) =>
  ({
    [PROJECT_STEP_PRIORITY_TYPE_ENUM.NON_URGENT]: (
      <FormattedMessage id="enum.projectStepPriorityType.nonUrgent" defaultMessage="Düşük" />
    ),
    [PROJECT_STEP_PRIORITY_TYPE_ENUM.URGENT]: (
      <FormattedMessage id="enum.projectStepPriorityType.urgent" defaultMessage="Orta" />
    ),
    [PROJECT_STEP_PRIORITY_TYPE_ENUM.VERY_URGENT]: (
      <FormattedMessage id="enum.projectStepPriorityType.veryUrgent" defaultMessage="Yüksek" />
    ),
  })[projectStepPriorityType];

export enum PROJECT_STEP_STATUS_TYPE_ENUM {
  REQUESTED = 1,
  IN_PROGRESS = 2,
  COMPLETED = 3,
}

export const getProjectStepStatusTypeTranslated = (projectStepStatusType: number) =>
  ({
    [PROJECT_STEP_STATUS_TYPE_ENUM.REQUESTED]: (
      <FormattedMessage id="enum.projectStepStatusType.requested" defaultMessage="İster" />
    ),
    [PROJECT_STEP_STATUS_TYPE_ENUM.IN_PROGRESS]: (
      <FormattedMessage id="enum.projectStepStatusType.inProgress" defaultMessage="Devam Ediyor" />
    ),
    [PROJECT_STEP_STATUS_TYPE_ENUM.COMPLETED]: (
      <FormattedMessage id="enum.projectStepStatusType.completed" defaultMessage="Tamamlandı" />
    ),
  })[projectStepStatusType];

export enum PROJECT_STEP_RESPONSIBLE_CONTACT_TYPE_ENUM {
  CUSTOMER = 1,
  IDECON = 2,
  CUSTOMER_AND_IDECON = 3,
}

export const getProjectStepResponsibleContactTypeTranslated = (projectStepResponsibleContactType: number) =>
  ({
    [PROJECT_STEP_RESPONSIBLE_CONTACT_TYPE_ENUM.CUSTOMER]: (
      <FormattedMessage id="enum.projectStepResponsibleContactType.customer" defaultMessage="Müşteri" />
    ),
    [PROJECT_STEP_RESPONSIBLE_CONTACT_TYPE_ENUM.IDECON]: (
      <FormattedMessage id="enum.projectStepResponsibleContactType.idecon" defaultMessage="Idecon" />
    ),
    [PROJECT_STEP_RESPONSIBLE_CONTACT_TYPE_ENUM.CUSTOMER_AND_IDECON]: (
      <FormattedMessage
        id="enum.projectStepResponsibleContactType.customerAndIdecon"
        defaultMessage="Müşteri / Idecon"
      />
    ),
  })[projectStepResponsibleContactType];

export enum EFFORT_MAIL_CONTACT_TYPE_ENUM {
  ONLY_RELATED_CONTACTS = 1,
  RELATED_CONTACTS_AND_REQUESTER = 2,
}

export const getEffortMailContactTypeTranslated = (effortMailContactType: number) =>
  ({
    [EFFORT_MAIL_CONTACT_TYPE_ENUM.ONLY_RELATED_CONTACTS]: (
      <FormattedMessage id="enum.effortMailContactType.onlyRelatedContacts" defaultMessage="Sadece İlgili Kişiler" />
    ),
    [EFFORT_MAIL_CONTACT_TYPE_ENUM.RELATED_CONTACTS_AND_REQUESTER]: (
      <FormattedMessage
        id="enum.effortMailContactType.relatedContactsAndRequester"
        defaultMessage="İlgili Kişiler ve Talep Eden"
      />
    ),
  })[effortMailContactType];
